<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-between flex-wrap">
  <div class="flex align-items-center justify-content-center">
    <p-breadcrumb [model]="pageVars.breadcrumbItems">
      <ng-template let-item let-last="last" let-first="first" pTemplate="item">
        <ng-container *ngIf="!first">
          <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
          <div *ngIf="!item.routerLink" class="breadcrumb-current-item">{{ item.label }}</div>
        </ng-container>
      </ng-template>
    </p-breadcrumb>
  </div>
  <div class="flex align-items-center justify-content-center">
    <p-button icon="pi pi-refresh" [raised]="true" class="mr-2" (click)="resetPage(dt)"></p-button>
    <p-button icon="pi pi-filter-slash" [raised]="true" *ngIf="filtersActive" (click)="clearFilters(dt)"></p-button>
  </div>
  <div class="flex align-items-center justify-content-center">
    <p-button
      label="Add Set-Up Date"
      [raised]="true"
      class="mr-2"
      iconPos="right"
      (onClick)="addSetupDate()"
      [disabled]="selectedOrderItemInstances.length === 0"></p-button>
    <p-button
      label="Update Container Quantity"
      [raised]="true"
      class="mr-2"
      iconPos="right"
      (onClick)="updateContainerQuantity()"
      [disabled]="selectedOrderItemInstances.length === 0"></p-button>
    <p-splitbutton
      label="Deliver/Ship"
      [model]="deliverShipMenuItems"
      [raised]="true"
      class="mr-2"
      [disabled]="selectedOrderItemInstances.length === 0"
      (onClick)="showDeliveryLocationDlg()"></p-splitbutton>
    <p-button
      label="Print Labels"
      [raised]="true"
      class="mr-2"
      iconPos="right"
      (onClick)="printLabels()"
      [disabled]="selectedOrderItemInstances.length === 0"></p-button>
    <p-button class="mr-2" label="Export" [raised]="true" iconPos="right" (onClick)="exportThisList()"></p-button>
  </div>
</div>

<p-table
  #dt
  [value]="orderItemInstances"
  [columns]="cols"
  [reorderableColumns]="true"
  [resizableColumns]="true"
  columnResizeMode="expand"
  [paginator]="true"
  [first]="skip"
  [rows]="take"
  [totalRecords]="totalCount"
  [lazy]="true"
  stateStorage="local"
  stateKey="insect-prep-table"
  (onLazyLoad)="handleTableEvents($event)"
  [(selection)]="selectedOrderItemInstances"
  dataKey="InstanceId"
  [scrollable]="true"
  [scrollHeight]="'60vh'">
  <ng-template #header let-columns>
    <tr>
      <th style="width: 3rem">
        <p-checkbox inputId="selectAll" [binary]="true" [ngModel]="selectAllToggle" (click)="toggleSelectAll(!selectAllToggle)"></p-checkbox>
      </th>
      <th
        *ngFor="let col of columns"
        pResizableColumn
        pReorderableColumn
        [pSortableColumn]="col.field"
        [ngStyle]="col.headerStyle || getColumnHeaderStyle(col.field)">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
        <p-columnFilter
          [type]="col.type"
          [field]="col.field"
          placeholder="Filter.."
          display="menu"
          class="ml-1"
         [matchModeOptions]="col.type === 'text' ? customMatchModeOptions : col.type === 'date' ? dateMatchModeOptions : col.type === 'numeric' ? numericMatchModeOptions : undefined">
        </p-columnFilter>
      </th>
    </tr>
  </ng-template>

  <ng-template #body let-order let-columns="columns">
    <tr>
      <td>
        <p-checkbox [value]="order.InstanceId" [(ngModel)]="selectedOrderItemInstances" (onChange)="selectRowClick()"></p-checkbox>
      </td>
      <td *ngFor="let col of columns" [ngStyle]="col.style">
        <ng-container [ngSwitch]="col.template">
          <a *ngSwitchCase="'link'" [routerLink]="['/orders', order.OrderId, 'insectprep']">
            {{ order[col.field] }}
          </a>
          <div *ngSwitchCase="'variant'" style="white-space: normal; overflow-wrap: break-word; word-break: break-word">
            {{ order[col.field] }}
          </div>
          <div *ngSwitchCase="'tooltip'" [pTooltip]="order[col.field]" tooltipPosition="top" class="text-line-clamp-3">
            {{ order[col.field] }}
          </div>
          <span *ngSwitchCase="'boolean'">
            {{ order[col.field] === true ? 'Yes' : 'No' }}
          </span>
          <ng-container *ngSwitchDefault>
            {{ order[col.field] }}
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="cols.length + 1">No orders found.</td>
    </tr>
  </ng-template>

</p-table>

<p-dialog
  *ngIf="showSetupDateModel"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showSetupDateModel"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '30rem' }">
  <h4 style="font-weight: bold; margin-top: 0px">Set Up Date</h4>
  <div class="grid">
    <div class="col mb-2 mt-2">
      <div class="flex align-content-center flex-wrap w-full">
        <p-floatlabel variant="on">
          <p-datepicker
            class="required"
            id="setUpDate"
            [(ngModel)]="setUpDate"
            [showIcon]="true"
            data-testId="setUpDate"
            [iconDisplay]="'input'"
            inputId="icondisplay"
            appendTo="body"></p-datepicker>
          <label for="on_label">Set Up Date</label>
        </p-floatlabel>
      </div>
    </div>
  </div>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancelSetupDate()" data-testid="newItemCancel" />
    <p-button label="Add" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="onSaveSetupDate()" data-testid="newItemSave" />
  </div>
</p-dialog>

<!-- Container Quantity Dialog -->
<p-dialog
  *ngIf="showContainerQuantityModal"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showContainerQuantityModal"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '30rem' }">
  <h4 style="font-weight: bold; margin-top: 0px">Container Quantity</h4>
  <div class="grid">
    <div class="col mb-2 mt-2">
      <div class="flex align-content-center flex-wrap w-full">
        <p-floatlabel variant="on">
          <p-inputnumber
            class="required"
            id="containerQuantity"
            [(ngModel)]="containerQuantity"
            data-testId="containerQuantity"
            [showButtons]="true"
            [min]="0"></p-inputnumber>
          <label for="containerQuantity">Quantity</label>
        </p-floatlabel>
      </div>
    </div>
  </div>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancelContainerQuantity()" data-testid="cancelContainerQuantity" />
    <p-button label="Update" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="onSaveContainerQuantity()" data-testid="saveContainerQuantity" />
  </div>
</p-dialog>

<!-- Delivery Location Dialog -->
<p-dialog
  [(visible)]="showDeliveryLocationDialog"
  header="Select Delivery Location"
  [modal]="true"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '30rem' }">
  <div class="form-row">
    <p-floatLabel class="mt-1" variant="on" style="width: 100%">
      <p-treeselect
        inputId="deliveryLocationId"
        [(ngModel)]="deliveryLocation"
        (ngModelChange)="computeDeliverDialogValidation(false)"
        [options]="deliveryLocations"
        class="w-full required"
        containerStyleClass="w-full"
        appendTo="body">
      </p-treeselect>
      <label for="deliveryLocationId">Delivery Location</label>
    </p-floatLabel>
  </div>
  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="cancelDeliveryLocationDlg()" />
      <p-button label="Save" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="saveDeliveryLocation()" [disabled]="!isDeliverDialogValid" />
    </div>
  </ng-template>
</p-dialog>

<!-- Shipping Dialog -->
<p-dialog
  [(visible)]="showShippingDialog"
  header="Add Shipping Information"
  [modal]="true"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '30rem' }">
  <div class="grid">
    <div class="col-12 mb-2">
      <p-floatLabel variant="on" style="width: 100%">
        <input pInputText id="shippingVendor" [(ngModel)]="shippingInfo.shippingVendor" (ngModelChange)="onShippingVendorChange()" class="w-full required" />
        <label for="shippingVendor">Shipping Vendor</label>
      </p-floatLabel>
    </div>
    <div class="col-12 mb-2">
      <p-floatLabel variant="on" style="width: 100%">
        <input pInputText id="shippingTracking" [(ngModel)]="shippingInfo.shippingTrackingNumber" (ngModelChange)="onShippingTrackingChange()" class="w-full required" />
        <label for="shippingTracking">Tracking Number</label>
      </p-floatLabel>
    </div>
    <div class="col-12 mb-2">
      <p-floatLabel variant="on" style="width: 100%">
        <p-datepicker
          [(ngModel)]="shippingInfo.shippingDate"
          (ngModelChange)="onShippingDateChange()"
          [showIcon]="true"
          [iconDisplay]="'input'"
          inputId="shippingDate"
          dateFormat="mm/dd/yy"
          appendTo="body"
          class="w-full required"></p-datepicker>
        <label for="shippingDate">Shipping Date</label>
      </p-floatLabel>
    </div>
  </div>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="cancelShippingDlg()" />
    <p-button label="Save" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="saveShippingInfo()" [disabled]="!isShipDialogValid" />
  </div>
</p-dialog>

<!-- Print Labels -->
<app-print-label
  [open]="showPrintModal"
  [orderItemInstanceIds]="selectedOrderItemInstanceIds"
  (close)="showPrintModal = false"
  (printed)="afterPrintLabels()">
</app-print-label>
